import { useState } from "react";
import { useAuth } from "../auth/AuthProvider";
import { ChatPanel } from "./ChatPanel";
import { CollaboratorPanel } from "./CollaboratorPanel";
import { SettingsPanel } from "./SettingsPanel";

type Tab = "claude" | "gemini" | "grok" | "collaborator";

export function Layout() {
  const [tab, setTab] = useState<Tab>("claude");
  const [settingsOpen, setSettingsOpen] = useState(false);
  const { user, signOut } = useAuth();

  return (
    <div className="app">
      <header className="app__header">
        <div className="app__brand">gen_ask_me_anything</div>
        <nav className="app__tabs" aria-label="Agent tabs">
          {(["claude", "gemini", "grok", "collaborator"] as Tab[]).map((t) => (
            <button
              key={t}
              className={`tab ${tab === t ? "tab--active" : ""}`}
              onClick={() => setTab(t)}
            >
              {label(t)}
            </button>
          ))}
        </nav>
        <div className="app__right">
          <span className="app__user" title={user?.email}>{user?.name ?? user?.email}</span>
          <button className="icon-btn" onClick={() => setSettingsOpen(true)} aria-label="Settings">
            ⚙
          </button>
          <button className="icon-btn" onClick={signOut} aria-label="Sign out" title="Sign out">⏻</button>
        </div>
      </header>

      <main className="app__main">
        {/*
         * Always mount all four panels and toggle visibility with CSS.
         * Otherwise React's reconciler either (a) reuses the same ChatPanel
         * instance across claude/gemini/grok prop changes — making the same
         * messages appear under every tab — or (b) unmounts ChatPanel when
         * switching to Collaborator and back, wiping history. Always-mount
         * keeps each panel's local state intact per agent.
         */}
        {(["claude", "gemini", "grok"] as const).map((a) => (
          <div key={a} style={{ display: tab === a ? "contents" : "none" }}>
            <ChatPanel agent={a} />
          </div>
        ))}
        <div style={{ display: tab === "collaborator" ? "contents" : "none" }}>
          <CollaboratorPanel />
        </div>
      </main>

      {settingsOpen && <SettingsPanel onClose={() => setSettingsOpen(false)} />}
    </div>
  );
}

function label(t: Tab): string {
  switch (t) {
    case "claude": return "Claude";
    case "gemini": return "Gemini";
    case "grok": return "Grok";
    case "collaborator": return "Collaborator";
  }
}
